export const OCC_ENDPOINTS = {
  searchCompany: 'b2bunits/suggestions',
  userCompanies: 'current-user/organizations',
  removeCompany: 'current-user/organizations/${companyId}',
  creditContracts: 'current-user/organizations/${organizationUid}/credit-contracts',
};
